module.exports = __webpack_public_path__ + "assets/img/join2021_003.07016064.png";